

import React, { useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid } from '@mui/material';
import { CssTextField } from '../elements';
import { Typography } from '@mui/material';
import { useAuth } from '../../../hooks/useAuth';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import TocIcon from '@mui/icons-material/Toc';
import { addSellCredit, addSellMaterial, getLangProgramTag, getSellCredit, getSellStatusTag, setSellCredit, setSellMaterial } from '../../../services/material-services';
import {NotificationManager} from 'react-notifications';
import PropTypes from 'prop-types';
import { blue } from '@mui/material/colors';
import MaterialSelectAuto from '../../materials/mat-select-auto';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ProgramLangSelect from './untils/select-lang';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import CloudSyncIcon from '@mui/icons-material/CloudSync';
import ImportExportIcon from '@mui/icons-material/ImportExport';


export default function SellStartNew({userClient, ReqUser, onClose}) {
    const { authData } = useAuth()
    // const { onClose, selectedValue, open } = props
    const [isAdmin, setIsAdmin] = useState(false)
    // const [error, setError] = useState(false)
    const [loading, setLoading] = useState(false)

    const [sellID, setSellID ] = useState(0)
    const [matName, setMatName ] = useState('')
    const [projectName, setProjectName] = useState('')
    const [programmerLang, setProgrammerLang] = useState('')
    const [numberOrder, setNumberOrder] = useState('')
    const [moreDetail, setMoreDetail] = useState('')
    const [remarks, setRemarks] = useState('')
    const [projectStatus, setProjectStatus] = useState('')
    const [estimateCredit, setEstimateCredit] = useState(0)
    const [totalCredit, setTotalCredit] = useState(0)
    const [creditID, setCreditID] = useState(0)

    const [langProgram, setLangProgram] = useState(false)
    const [sellStsList, setSellStsList] = useState('')

    const handlerLangSelect = value => {
        // console.log("handlerLangSelect", value)
        setProgrammerLang(value)
    }

    const handlerStatusSelect = value => {
        // console.log("handlerLangSelect", value)
        setProjectStatus(value)
    }

    useEffect(()=>{
        if(authData?.user){
            setIsAdmin(authData.user?.profile?.is_permium)
        }
        setLoading(true)
        // console.log("ReqUser:", ReqUser)
        if(ReqUser?.sell_req_buys?.id){
            setSellID(ReqUser?.sell_req_buys?.id)
        }
        if(ReqUser?.sell_req_buys?.material){
            setMatName(ReqUser?.sell_req_buys?.material)
        }
        if(ReqUser?.sell_req_buys?.name_project){
            setProjectName(ReqUser?.sell_req_buys?.name_project)
        }
        if(ReqUser?.sell_req_buys?.lang_programs){
            setProgrammerLang(ReqUser?.sell_req_buys?.lang_programs)
        }
        if(ReqUser?.sell_req_buys?.order_number){
            setNumberOrder(ReqUser?.sell_req_buys?.order_number)
        }
        if(ReqUser?.sell_req_buys?.bio){
            setMoreDetail(ReqUser?.sell_req_buys?.bio)
        }
        if(ReqUser?.sell_req_buys?.remarks){
            setRemarks(ReqUser?.sell_req_buys?.remarks)
        }
        const getData = async() =>{
            await getLangProgramTag(authData?.token)
            .then(data => {
                
                // console.log("setLangProgram", data)
                setLangProgram(data)

                setLoading(false)
            }).catch( e => {
                // setError(true)
                setLoading(false)
            })
        }
        getData()
    }, [ReqUser, authData])

    useEffect(() => {
        
        const getCreditData = async() =>{
            await getSellCredit(authData?.token, sellID)
            .then(data => {
                
                console.log("getSellCredit", data)
                setEstimateCredit(data?.estimate_credit)
                setTotalCredit(data?.total_credit)
                setCreditID(data?.id)
    
                setLoading(false)
            }).catch( e => {
                // setError(true)
                setLoading(false)
            })
        }
        if(isAdmin && sellID > 0){
            getCreditData()
        }
    }, [authData, sellID, isAdmin])

    useEffect(()=>{
        const getData = async() =>{
            setLoading(true)
            await getSellStatusTag(authData?.token)
            .then(data => {
                
                // console.log("setLangProgram", data)
                setSellStsList(data)

                setLoading(false)
            }).catch( e => {
                // setError(true)
                setLoading(false)
            })
        }
        getData()
    }, [authData])

    const handelSubmitInsert = async e => {
        // e.preventDefault()
        setLoading(true)
        // const dateMiladi = moment(entryTime, 'jYYYY/jM/jD').format('YYYY-M-D')
        // console.log("sellID", data)
        let addNewSellMat = ''
        // let addNewCredit = ''
        if(sellID <= 0){
            const data = {user: userClient.id, material:matName.id, req_buy: ReqUser.id
                        , name_project: projectName, order_number: numberOrder, bio: moreDetail
                        , lang_programs: programmerLang,  
                        remarks: remarks}
            addNewSellMat = await addSellMaterial(authData.token, data)
            setNumberOrder(addNewSellMat?.order_number)
            // console.log("addNewSellMat:", addNewSellMat)
            addNewSellMat = await addSellCredit(authData.token, 
                    {sell_mat: addNewSellMat.id, estimate_credit: estimateCredit, 
                    total_credit: totalCredit})
                        
        }else{
            const data = {user: userClient.id, material:matName.id, req_buy: ReqUser.id
                        , name_project: projectName, bio: moreDetail
                        , lang_programs: programmerLang, remarks: remarks}
            addNewSellMat = await setSellMaterial(authData.token, sellID, data)
            // console.log(addNewSellMat)
            addNewSellMat = await setSellCredit(authData.token, creditID, 
                {sell_mat:sellID, estimate_credit: estimateCredit, total_credit: totalCredit})

        }
        // const dataBack = { 'bio_step': bio_step, "expire_time": expire_time, "detail_id": detail_id}
        // onClose(addNewBuyMaterial)
        // console.log("addNewBuyMaterial", addNewBuyMaterial)
        if (addNewSellMat){
            NotificationManager.success('جزئیات جدید به برنامه اضافه شد')
        }else{
            NotificationManager.error('متاسفانه خطایی در زمان ثبت جزئیات وجود دارد')
        }
        setLoading(false)
    }

    const handleMatSelect = value => {
        setMatName(value)
    }

  return (
    <div style={{direction: 'rtl'}}>
        <Accordion sx={{backgroundColor: blue[900], margin: 1}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{color: 'pink.text'}}/>}
                aria-controls="panel2a-content"
                id="panel2a-header"
                >
                <Typography
                    fontFamily='b_mitra' 
                    component="div"
                    variant="h6"
                    color={"pink.text"}
                    >
                    پروژه {numberOrder &&
                        "(شماره سفارش :" + numberOrder + ")"
                    }
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{backgroundColor: 'white', padding: 10}} >
                    <br/>
                    <Grid container sx={{marginTop: 1, marginRight:1, marginLeft:1}}>
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid container spacing={1} alignItems='flex-end'>
                                <Grid item>
                                    <TocIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item >
                                    <MaterialSelectAuto 
                                        onChange={handleMatSelect}
                                        selectedValue={matName} />
                                </Grid>
                                <Grid item>
                                    *
                                </Grid>
                            </Grid>
                            <Grid item>
                                <AccountTreeIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={4}>
                                <CssTextField  
                                    label={(
                                        <Typography 
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={blue[900]}
                                            >
                                            *نام پروژه
                                        </Typography>
                                    )}
                                    fullWidth
                                    disabled={!isAdmin}
                                    inputProps={{ style: { color: blue[900], fontFamily: "b_mitra"}}}
                                    variant="standard" value={projectName}
                                    onChange={ e => setProjectName( e.target.value )} />
                            </Grid>
                            
                        </Grid>
                        {isAdmin &&
                            <div>
                                <Grid container spacing={1} alignItems='flex-end'>
                                    <Grid item>
                                        <BorderColorIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4} sx={{fontFamily: 'b_mitra'}}>
                                        <CssTextField
                                            label={(
                                                <Typography 
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={blue[900]}
                                                    >
                                                    *پیش بینی حدود قیمت
                                                </Typography>
                                            )}
                                            fullWidth
                                            disabled={!isAdmin}
                                            inputProps={{ style: { color: blue[900], fontFamily: "b_mitra"}}}
                                            variant="standard" value={estimateCredit}
                                            onChange={ e => setEstimateCredit( e.target.value )} />
                                    </Grid>
                                    <Grid item>
                                        <BorderColorIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                    </Grid>
                                    <Grid item xs={4} sx={{fontFamily: 'b_mitra'}}>
                                        <CssTextField  
                                            label={(
                                                <Typography 
                                                    fontFamily='b_mitra' 
                                                    component="div"
                                                    variant="h6"
                                                    color={blue[900]}
                                                    >
                                                    *مبلغ تمام شده
                                                </Typography>
                                            )}
                                            fullWidth
                                            disabled={!isAdmin}
                                            inputProps={{ style: { color: blue[900], fontFamily: "b_mitra"}}}
                                            variant="standard" value={totalCredit}
                                            onChange={ e => setTotalCredit( e.target.value )} />
                                    </Grid>
                                </Grid>
                            </div>
                        }
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <CalendarTodayIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={4} sx={{fontFamily: 'b_mitra'}}>
                                <CssTextField  
                                    label={(
                                        <Typography 
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={blue[900]}
                                            >
                                            مختصری از پروژه
                                        </Typography>
                                    )}
                                    fullWidth
                                    disabled={!isAdmin}
                                    variant="standard" value={moreDetail}
                                    onChange={ e => setMoreDetail( e.target.value )} />
                            </Grid>

                        </Grid>
                        {isAdmin &&
                            <Grid container spacing={1} alignItems='flex-end'>
                                <Grid item>
                                    <MoreHorizIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                                </Grid>
                                <Grid item xs={6} sx={{fontFamily: 'b_mitra'}}>
                                    <ProgramLangSelect 
                                        title="انتخاب وضعیت پروژه"
                                        dataAll={sellStsList} 
                                        selectValue={projectStatus} 
                                        onClose={handlerStatusSelect}/>
                                </Grid>
                            </Grid>
                        }
                        <Grid container spacing={1} alignItems='flex-end'>
                            <Grid item>
                                <CloudSyncIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={6}>
                                <ProgramLangSelect 
                                    title="انتخاب برنامه"
                                    dataAll={langProgram} 
                                    selectValue={ReqUser?.sell_req_buys?.lang_programs} 
                                    onClose={handlerLangSelect}/>
                            </Grid>
                        </Grid>
                        <Grid container spacing={1} alignItems='flex-end' >
                            <Grid item>
                                <ImportExportIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
                            </Grid>
                            <Grid item xs={10} sx={{fontFamily: 'b_mitra'}}>
                                <CssTextField  
                                    label={(
                                        <Typography 
                                            fontFamily='b_mitra' 
                                            component="div"
                                            variant="h6"
                                            color={blue[900]}
                                            >
                                            توضیحات
                                        </Typography>
                                    )}
                                    fullWidth
                                    multiline
                                    rows={2}
                                    disabled={!isAdmin}
                                    inputProps={{style: {color: blue[900]}}}
                                    variant="standard" value={remarks}
                                    onChange={ e => setRemarks( e.target.value )} />
                            </Grid>
                        </Grid>
                        {isAdmin &&
                            <Grid container spacing={1} alignItems='flex-end' >
                                <Grid item xs={10} sm={10} textAlign={'right'}>
                                    <Button 
                                        variant="contained" 
                                        color="primary"
                                        size="small" 
                                        onClick={handelSubmitInsert}
                                        >
                                            <Typography
                                                fontFamily='b_mitra' 
                                                component="div"
                                                variant="h6"
                                                color={'pink.text'}
                                                >
                                                ذخیره
                                            </Typography>
                                    </Button>
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                </div>
            </AccordionDetails>
        </Accordion>
    </div>
  )
}


SellStartNew.propTypes = {
    onClose: PropTypes.func.isRequired,
    // open: PropTypes.bool.isRequired,
    // selectedValue: PropTypes.string.isRequired,
}